import Seo from "@/components/Seo";
import { PageHero, Btn, DevisCta } from "@/components/Shared";
import { UtensilsCrossed, Hammer, Bell } from "lucide-react";

export default function TablechoPage() {
  return (
    <div data-testid="page-tablecho">
      <Seo
        title="Tablecho — application en construction pour la restauration — Form Action Pro"
        description="Tablecho est une application en construction pour les professionnels de la restauration, portée par François Schoonheere. Présentation honnête, sans promesse excessive."
        path="/tablecho"
      />
      <PageHero
        kicker="Le projet Tablecho"
        title="Une application en construction pour les professionnels de la restauration"
        subtitle="Tablecho est un projet porté par François Schoonheere. Cette page dit où en est le projet — rien de plus, rien de moins."
      />

      <section className="bg-sable py-16">
        <div className="max-w-4xl mx-auto px-6 space-y-10">
          <div className="flex gap-4">
            <UtensilsCrossed className="text-vert-dark shrink-0 mt-1" size={24} />
            <div>
              <h2 className="font-serif text-xl text-marine mb-2">Pour qui ?</h2>
              <p className="font-sans text-base text-marine/80 leading-[1.7]">
                Pour les professionnels de la restauration indépendante. Le projet naît de 35 ans de
                terrain dans le métier — cuisines, direction, multi-sites.
              </p>
            </div>
          </div>
          <div className="flex gap-4">
            <Hammer className="text-vert-dark shrink-0 mt-1" size={24} />
            <div>
              <h2 className="font-serif text-xl text-marine mb-2">Où en est le projet ?</h2>
              <p className="font-sans text-base text-marine/80 leading-[1.7]">
                En construction. L’application est en cours de développement et de financement
                participatif. Nous ne promettons ni date ferme ni fonctionnalités non finalisées :
                le site du projet présente l’avancement réel, au fil de l’eau.
              </p>
            </div>
          </div>
          <div className="flex gap-4">
            <Bell className="text-vert-dark shrink-0 mt-1" size={24} />
            <div>
              <h2 className="font-serif text-xl text-marine mb-2">Être tenu informé</h2>
              <p className="font-sans text-base text-marine/80 leading-[1.7]">
                Si le projet vous intéresse, vous pouvez laisser vos coordonnées sur le site
                Tablecho pour être prévenu du lancement.
              </p>
            </div>
          </div>
          <div className="pt-4">
            <Btn
              href="https://tablecho.com"
              external
              testid="tablecho-cta-lancement"
              variant="primary"
            >
              Être prévenu du lancement
            </Btn>
          </div>
        </div>
      </section>

      <DevisCta />
    </div>
  );
}
